import React from "react";

class UniversalDuoInfoComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        return (
            <div className="center push--top">
                <div className="duo-width">
                    <h2 id="pageTitle" className="text--center">Manage Duo Two-Factor Authentications</h2>
                    <p>For users who will use <b>cmegroup.com</b> entitled applications and
                    services, the Duo Mobile app and your mobile device make Two-Factor Authentication easy. Therefore,
                    install Duo on your device; then you may modify your CME Group Login profile to identify the device
                    and how you wish to authenticate.</p>
                </div>
            </div>
        );
    }

}

UniversalDuoInfoComponent.propTypes = {
};

export default UniversalDuoInfoComponent;